export const chat = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'chat', activeChatChannel: s.root.activeChatChannel || 'cabinet-1' })) } return false } })() },

  NavSidebar: {},

  ChatSidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'hidden',
    height: '100vh',

    TopBar: {},

    ChannelHeader: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Z A',
      borderBottom: '1px solid inkBorder',
      background: 'inkMid',
      ChannelName: {
        flow: 'x', gap: 'Y', align: 'center flex-start',
        Hash: { text: '#', fontSize: 'A', fontWeight: '700', color: 'teal' },
        Name: {
          text: (el, s) => {
            const ch = s.root.activeChatChannel || 'cabinet-1'
            const names = { 'cabinet-1': 'Cabinet 1', 'cabinet-2': 'Cabinet 2', 'reception': 'Reception', 'doctors': 'Doctors', 'management': 'Management', 'general': 'General', 'dm-kvaratskhelia': 'Dr. Kvaratskhelia', 'dm-beridze': 'Dr. Beridze', 'dm-nino': 'Hygienist Nino' }
            return names[ch] || ch
          },
          fontSize: 'A', fontWeight: '600', color: 'inkText'
        }
      },
      MemberCount: { text: '6 Members', fontSize: 'Y', color: 'inkMuted' }
    },

    MessageThread: {
      flow: 'y',
      gap: '0',
      flex: '1',
      overflow: 'auto',
      background: 'inkSurface',

      // ─── SAMPLE MESSAGES ─────────────────────────
      Msg1: {
        extends: 'ChatMessage',
        state: {
          initials: 'GK',
          avatarColor: 'teal.15',
          avatarTextColor: 'teal',
          sender: 'Dr. Kvaratskhelia',
          timestamp: '09:12',
          text: 'Cabinet 1 is ready for the crown prep. Patient Kapanadze has arrived and is in the chair.',
          status: 'read',
          urgency: 'normal'
        }
      },

      Msg2: {
        extends: 'ChatMessage',
        state: {
          initials: 'NT',
          avatarColor: 'amber.15',
          avatarTextColor: 'amber',
          sender: 'Hygienist Nino',
          timestamp: '09:15',
          text: 'X-rays are uploaded to the chart. Periapical on #14 shows slight radiolucency — please review before proceeding.',
          status: 'read',
          urgency: 'important'
        }
      },

      Msg3: {
        extends: 'ChatMessage',
        state: {
          initials: 'NB',
          avatarColor: 'purple.15',
          avatarTextColor: 'purple',
          sender: 'Dr. Beridze',
          timestamp: '09:18',
          text: 'I can see it on the PA. Looks like a small periapical lesion. Recommend vitality test before crown prep. May need endo consult.',
          status: 'delivered',
          urgency: 'normal'
        }
      },

      Msg4: {
        extends: 'ChatMessage',
        state: {
          initials: 'MR',
          avatarColor: 'blue.15',
          avatarTextColor: 'blue',
          sender: 'Maria (Reception)',
          timestamp: '09:22',
          text: 'Patient in Cabinet 2 just called — running 15 minutes late. Should I adjust the schedule?',
          status: 'read',
          urgency: 'normal'
        }
      },

      Msg5: {
        extends: 'ChatMessage',
        state: {
          initials: 'GK',
          avatarColor: 'teal.15',
          avatarTextColor: 'teal',
          sender: 'Dr. Kvaratskhelia',
          timestamp: '09:24',
          text: 'Yes, push Cabinet 2 back 15 min. Also — we need the endo kit in Cabinet 1 ASAP. Vitality test is negative on #14.',
          status: 'delivered',
          urgency: 'urgent'
        }
      },

      Msg6: {
        extends: 'ChatMessage',
        state: {
          initials: 'NT',
          avatarColor: 'amber.15',
          avatarTextColor: 'amber',
          sender: 'Hygienist Nino',
          timestamp: '09:26',
          text: 'Endo kit on its way. I will prep the rubber dam setup as well.',
          status: 'sent',
          urgency: 'normal'
        }
      },

      Msg7: {
        extends: 'ChatMessage',
        state: {
          initials: 'NB',
          avatarColor: 'purple.15',
          avatarTextColor: 'purple',
          sender: 'Dr. Beridze',
          timestamp: '09:30',
          text: 'I can take over Cabinet 2 while you handle the endo. My 10:00 just cancelled.',
          status: 'read',
          urgency: 'normal'
        }
      }
    },

    ChatInput: {}
  }
}
